import {createStrokeSVG} from './TEMPLATE'

// tabler: plus
export const PlusLarge_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: ['M12 5l0 14', 'M5 12l14 0'],
  viewBox: '2 2 20 20',
  strokeWidth: 2,
})

// tabler: plus
export const PlusSmall_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: ['M12 5l0 14', 'M5 12l14 0'],
  viewBox: '-3 -3 30 30',
  strokeWidth: 2,
})
